import axios from "../../config/axiosConfig";
import { CREATE_ITEM, GET_ITEM, ITEM_REQUEST,DELETE_ITEM, UPDATE_ITEM, ITEM_REQUEST_FAILURE, GET_ITEMS_PAGE, ITEM_REQUEST_SUCCESS } from "../types";
import { addMasterInOption, updateMasterInOption } from './master-options-actions';


export const getItemsWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal, commonMaster) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: ITEM_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, company_id: auth.company?.id, customerId: auth?.user?.Customer_Id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
        includeAttr: 'HSN_Code'
      };
      if (!auth?.company?.Common_Master) {
        params = { ...params, companyId: auth.company?.id }
      }
      if (commonMaster !== undefined) {
        params = {
          ...params,
          companyId: commonMaster ? undefined : auth.company?.id
        };
      }
      return axios.get("/item/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_ITEMS_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: ITEM_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: ITEM_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getItems = (commonMaster) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: ITEM_REQUEST });
            const { auth } = getState();
            let params = { customerId: auth?.user?.Customer_Id, company_id: auth?.company?.id };
            if (!auth?.company?.Common_Master) {
                params = { ...params, companyId: auth.company?.id }
            }
            if (commonMaster !== undefined) {
                params = {
                  ...params,
                  companyId: commonMaster ? undefined : auth.company?.id
                };
            }
            return axios.get('/item/getAll', { params }).then((response) => {
                if (response.data) {
                    dispatch({ type: GET_ITEM, payload: response.data });
                }
            }).catch((error) => {
                console.error(error);
                dispatch({ type: ITEM_REQUEST_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: ITEM_REQUEST_FAILURE, error: error.message });
        }
    };
};

export const getItemById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: ITEM_REQUEST });

      const { auth } = getState();
      const params = { customerId: auth?.user?.Customer_Id, companyId: auth?.company?.id };
      
      return axios.get(`/item/get/${id}`, { params }).then((response) => {
        dispatch({ type: ITEM_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: ITEM_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: ITEM_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const createItem = (item) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            dispatch({ type: ITEM_REQUEST });
            return axios.post('/item/add', item,
                { params: { userId: auth.user?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id }}
            ).then((response) => {
                if (response.data) {
                    dispatch({ type: CREATE_ITEM, payload: response.data });
                    dispatch(addMasterInOption('items', response.data));
                } else {
                    dispatch({ type: ITEM_REQUEST_FAILURE, error: 'Group create failed.' });
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: ITEM_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: ITEM_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const updateItem = (id, data) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            dispatch({ type: ITEM_REQUEST });
            return axios.put('/item/update', { id, data },
                { params: {
                    userId: auth.user?.id,
                    companyId: data.Company_Id || auth.company?.id,
                    customerId: data.Customer_Id || auth?.user?.Customer_Id
                }
            }).then((response) => {
                if (response.data) {
                    dispatch({ type: UPDATE_ITEM, payload: { id, data: response.data } });
                    dispatch(updateMasterInOption('items', id, response.data));
                } else {
                    dispatch({ type: ITEM_REQUEST_FAILURE, error: 'Group update failed.' });
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: ITEM_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: ITEM_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const deleteItem = (id) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: ITEM_REQUEST });
            return axios.delete(`/item/delete/${id}`).then((response) => {
                if (response.data) {
                    dispatch({ type: DELETE_ITEM, id: id });
                    dispatch(updateMasterInOption('items', id));
                    
                    const { item: { currentPage, pageSize, searchStr, where } } = getState();
                    const include = ['id', 'Item_Name', 'Item_Code', 'HSN_Code', 'UOM', 'Item_Group', 'Item_Status'].join(',');
                    const searchCols = ['Item_Name'].join(',');
                    dispatch(getItemsWithPagination(currentPage, pageSize, include, searchStr, searchCols, where, true));
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: ITEM_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: ITEM_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};
